import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly history: string[] = [];
  private readonly maxEntries = 50;
  private readonly router = inject(Router);

  constructor() {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
      const url = e.urlAfterRedirects ?? e.url;
      // avoid pushing duplicate consecutive entries
      if (this.history.length === 0 || this.history.at(-1) !== url) {
        this.history.push(url);
        if (this.history.length > this.maxEntries) this.history.shift();
      }
    });
  }

  // Return the previous visited url (one entry back). Returns null if not available.
  getPreviousUrl(): string | null {
    return this.history.at(-2) ?? null;
  }

  // Return n-th previous url (1 => immediate previous, 2 => one more back)
  getPreviousUrlN(n: number): string | null {
    const val = this.history.at(-(n + 1));
    return val ?? null;
  }

  // Expose full history copy (read-only)
  getHistory(): string[] {
    return [...this.history];
  }
}
